import { TemplateConfiguration } from '../models/app/TemplateConfiguration';

export const TEMPLATE_CONFIGURATION: TemplateConfiguration = {
    appConfigSource: 'files',
};



// WEBPACK FOOTER //
// ./src/configuration/development.templateConfig.ts